import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-link',
  standalone: true,
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.sass'],
  imports: [CommonModule],
})
export class LinkComponent {
  @Input()
  public label: string = 'Link';

  @Input()
  public classes: string = '';

  @Input()
  public href: string = '#';
  @Output()
  public readonly clickEvent: EventEmitter<Event> = new EventEmitter<Event>();
  @Input()
  private size: 'large' | 'big' | 'middle' | 'small' | 'base' = 'base';

  public get linkClasses(): string {
    return `link link-${this.size} ${this.classes}`;
  }
}
